import { useLoading, useError } from '../api/hooks';
import { useEffect } from 'react';
import { usePrevious } from './usePrevious';
import { ActionType } from '../redux/actionType';


/**
 * Triggers its callback when the given API action (and optional request ID) is successfully completed -- i.e. no error.
 */
export const useOnSuccess = (
  callback: (() => void) | undefined,
  actionType: ActionType,
  requestId: string | number | undefined = undefined,
) => {
  const loading     = useLoading(actionType, requestId);
  const error       = useError(actionType, requestId);
  const prevLoading = usePrevious(loading);

  useEffect(
    () => {
      if (prevLoading && !loading && !error) {
        callback?.();
      }
    },
    [prevLoading, loading, error, callback],
  );
};
